module.exports = __webpack_public_path__ + "static/media/banner_bg_right.a5a9930f.svg";